export default __webpack_public_path__ + "static/media/across.9ae872f4.svg";